<p-button [label]="label" [icon]="icon" [type]="type" [severity]="severity" [outlined]="outlined" [text]="text"
  [rounded]="rounded" [raised]="raised" [size]="size" [loading]="loading" [disabled]="isDisabled"
  [styleClass]="customClass" (onClick)="onClick($event)">
</p-button>